import { Hco } from '@/core/graphql/generated/types';

/**
 * Type predicate to check if an object is of type Hco.
 * Note: this is a loose type check
 */
export const isOfTypeHco = (hco: unknown): hco is Hco => {
	if (typeof hco === 'object' && hco !== null) {
		return '__typename' in hco && hco.__typename === 'HCO' && 'vid_V' in hco;
	}

	return false;
};
